export const MEMBERS_FETCH_REQUEST = 'gustav/settings/MEMBERS_FETCH_REQUEST';
export const MEMBERS_FETCH_SUCCESS = 'gustav/settings/MEMBERS_FETCH_SUCCESS';
export const MEMBERS_FETCH_ERROR = 'gustav/settings/MEMBERS_FETCH_ERROR';

export const MEMBER_INVITE_REQUEST = 'gustav/settings/MEMBER_INVITE_REQUEST';
export const MEMBER_INVITE_SUCCESS = 'gustav/settings/MEMBER_INVITE_SUCCESS';
export const MEMBER_INVITE_ERROR = 'gustav/settings/MEMBER_INVITE_ERROR';

export const FETCH_CAN_INVITE_REQUEST =
  'gustav/settings/FETCH_CAN_INVITE_REQUEST';
export const FETCH_CAN_INVITE_SUCCESS =
  'gustav/settings/FETCH_CAN_INVITE_SUCCESS';
export const FETCH_CAN_INVITE_ERROR = 'gustav/settings/FETCH_CAN_INVITE_ERROR';

export const MEMBER_RESEND_INVITE_REQUEST =
  'gustav/settings/MEMBER_RESEND_INVITE_REQUEST';
export const MEMBER_RESEND_INVITE_SUCCESS =
  'gustav/settings/MEMBER_RESEND_INVITE_SUCCESS';
export const MEMBER_RESEND_INVITE_ERROR =
  'gustav/settings/MEMBER_RESEND_INVITE_ERROR';

export const MEMBER_UPDATE_REQUEST = 'gustav/settings/MEMBER_UPDATE_REQUEST';
export const MEMBER_UPDATE_SUCCESS = 'gustav/settings/MEMBER_UPDATE_SUCCESS';
export const MEMBER_UPDATE_ERROR = 'gustav/settings/MEMBER_UPDATE_ERROR';

export const MEMBER_REMOVE_REQUEST = 'gustav/settings/MEMBER_REMOVE_REQUEST';
export const MEMBER_REMOVE_SUCCESS = 'gustav/settings/MEMBER_REMOVE_SUCCESS';
export const MEMBER_REMOVE_ERROR = 'gustav/settings/MEMBER_REMOVE_ERROR';
